const getApiKeys = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_GET_API_KEYS_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.get(`/proxy/ai/workspaces/${data.workspaceId}/api-key?customer_id=${data.customer_id}&channelType=${data.channelType}`, data);
        if (response && response.data.success) {
            commit("SET_API_KEYS", response.data.key);
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_GET_API_KEYS_LOADING", false);
    }
};

export default getApiKeys;